module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAAAXNSR0IArs4c6QAAANNJREFUOE9j7Orq+s9AAfjw4cOTtrY2WXxGMNLFEgo8QbRWRqJVUqCQPpbExMSsosCRDN++fXu3bt26DHpFPLuurq4fyLIPHz48ePz48WmYxYy6urqhlPjk9+/f32/cuLGFh4dHtK6u7hXIrLNnzy5YuXJlItwSSixA1ju0LbG3ty/19vbuIhQajKSmrm3bthW9e/fuCchgoi0htVjp7+/Xev78+XWQJVpaWn5GRkYxIDYrKyu7pqYmOHW9f/+estR1+fLlnQwMDJ/Qg2hoRzyxSRgAu6qECdk2LS0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/playlist-icon-b.png
// module id = 846
// module chunks = 0